/* Quiz La Cock-In — utilisé par sections/quiz-la-cockin.liquid */
(function () {
  var KEY = 'lcqQuiz';
  function save(state) { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; } }

  function init(root) {
    var steps = root.querySelectorAll('[data-step]');
    var questions = root.querySelectorAll('.lcq__q');
    var bar = root.querySelector('[data-bar]');
    var count = root.querySelector('[data-count]');
    var tags = root.querySelector('[data-tags]');
    var answers = {};
    var idx = 0;

    function show(name, scroll) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function focusIn(el) { var f = el && el.querySelector('[data-focus]'); if (f) f.focus({ preventScroll: true }); }

    function showQ(i) {
      idx = i;
      questions.forEach(function (q, j) { q.hidden = j !== i; });
      count.textContent = 'Question ' + (i + 1) + ' sur ' + questions.length;
      bar.style.width = (i / questions.length * 100) + '%';
      var first = questions[i].querySelector('.lcq__opt');
      if (first) first.focus({ preventScroll: true });
    }

    function profileOf(a) {
      if (a.target === 'homme') return 'gourmand';
      var beginner = a.level === 'decouvre';
      if (a.target === 'deux') return beginner ? 'complices' : 'audacieux';
      return beginner ? 'curieuse' : 'exploratrice';
    }

    function finish() {
      var state = { profile: profileOf(answers), budget: answers.budget, who: answers.who };
      save(state);
      tags.value = 'newsletter,quiz,quiz-' + state.profile;
      show('email', true);
      focusIn(root.querySelector('[data-step="email"]'));
    }

    function renderResult(state, withCode) {
      var active = null;
      root.querySelectorAll('.lcq__profile').forEach(function (el) {
        var on = el.getAttribute('data-profile') === state.profile;
        el.hidden = !on;
        if (on) active = el;
      });
      if (active && (state.budget === 'low' || state.budget === 'high')) {
        var list = active.querySelector('.lcq__grid');
        var items = Array.prototype.slice.call(list.children);
        items.sort(function (a, b) {
          var d = Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'));
          return state.budget === 'high' ? -d : d;
        });
        items.forEach(function (li) { list.appendChild(li); });
      }
      root.querySelector('[data-code-box]').hidden = !withCode;
      root.querySelector('[data-gift]').hidden = state.who !== 'cadeau';
      show('result', true);
      focusIn(active);
    }

    root.querySelector('[data-start]').addEventListener('click', function () {
      answers = {};
      show('questions', true);
      showQ(0);
    });

    root.querySelectorAll('.lcq__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.closest('.lcq__q');
        answers[q.getAttribute('data-q')] = btn.getAttribute('data-v');
        if (idx < questions.length - 1) { showQ(idx + 1); } else { bar.style.width = '100%'; finish(); }
      });
    });

    root.querySelector('[data-back]').addEventListener('click', function () {
      if (idx > 0) { showQ(idx - 1); } else { show('intro', true); focusIn(root.querySelector('[data-step="intro"]')); }
    });

    root.querySelector('[data-skip]').addEventListener('click', function () {
      var state = load();
      if (state) renderResult(state, false);
    });

    root.querySelector('[data-restart]').addEventListener('click', function () {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      answers = {};
      show('intro', true);
      focusIn(root.querySelector('[data-step="intro"]'));
    });

    var copyBtn = root.querySelector('[data-copy]');
    copyBtn.addEventListener('click', function () {
      var value = copyBtn.getAttribute('data-copy');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(value).then(function () { copyBtn.textContent = 'Code copié !'; }, function () {});
      }
    });

    var saved = load();
    var posted = root.querySelector('[data-posted]') || /customer_posted=true/.test(window.location.search);
    if (saved && root.querySelector('[data-form-error]')) {
      tags.value = 'newsletter,quiz,quiz-' + saved.profile;
      show('email', true);
    } else if (saved && posted) {
      renderResult(saved, true);
    }
  }

  function start() { document.querySelectorAll('.lcq').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();